module.exports = __webpack_public_path__ + "static/master_thiefs_tools-15c00fe98c4dab6ba62280bfd9dfa349.jpg";